export default __webpack_public_path__ + "static/silver_bundles_storycard-3414407018f2bb06e9a800b08de0ce37.png";